import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import CompetencyShape from './CompetencyShape';
import { TableContext } from '../../../components/Table/TableContext';

const propTypes = {
  competency: CompetencyShape,
};
const defaultProps = {
  competency: null,
};

export default function PartnerRowItem({
  competency: { id, name, referenceId },
}) {
  const { onClickEdit, onClickDelete } = useContext(TableContext);

  const handleClickEdit = () => onClickEdit(id);
  const handleClickDelete = () => onClickDelete(id);

  return (
    <tr>
      <td>{referenceId}</td>
      <td>{name}</td>
      <td>
        <div className="flex space-around space-between text-center">
          <Button
            className="p-1 me-1 text-dark"
            variant="link"
            type="button"
            title="Edit Specialty"
            onClick={handleClickEdit}
            data-testid="Button-editCompetency"
            role='button'
            aria-label='Edit Specialty'
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </Button>
          <Button
            className="p-1 text-dark"
            variant="link"
            type="button"
            title="Delete Specialty"
            onClick={handleClickDelete}
            data-testid="Button-deleteCompetency"
            role='button'
            aria-label='Delete Specialty'
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      </td>
    </tr>
  );
}

PartnerRowItem.propTypes = propTypes;
PartnerRowItem.defaultProps = defaultProps;
